import { render } from "./MessageReactions.vue?vue&type=template&id=2129eda2"
import script from "./MessageReactions.vue?vue&type=script&lang=js"
export * from "./MessageReactions.vue?vue&type=script&lang=js"

import "./MessageReactions.vue?vue&type=style&index=0&id=2129eda2&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__